export default __webpack_public_path__ + "static/media/twitter.93ac3f9a.png";